import React, { Component } from 'react';
import { post } from '../Services/http';
import LoadingButton from '../Components/LoadingButton'
import { translate } from '../Services/translation';

class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = this.getInitialState();
    }

    getInitialState() {
        return {
            email: "",
            isLoading: false,
            isCompleted: false,
            isError: false,
            invalidInput: false,
            redirecturl: this.props.redirecturl
        };
    }

    reset(loadingInterval) {
        this.setState(this.getInitialState());
        clearInterval(loadingInterval);
    }

    onSuccess() {
        this.setState({...this.getInitialState(), isCompleted: true})

        if (this.state.redirecturl) {
            setTimeout(() => {
                window.location.href = this.state.redirecturl;
            }, 2000);
        }
    }

    onError(ex) {
        this.setState({...this.getInitialState(), isError: true});
    }

    onInputChanged(event) {
        const eventValue = event.target.value
        this.setState({ [event.target.name]: eventValue }, 
            () => this.verifyEmailInput(eventValue, true))
    }

    verifyEmailInput(value, inputChange) {
        const valid = (inputChange === true && value === "") || (this.state.email !== "" && this.state.email.includes("@"));
        this.setState({invalidInput: !valid}); 

        return valid;
    }

    onSubmit() {
        if(!this.verifyEmailInput(this.state.email, false)) {
            return;
        }
        
        this.setState({ isLoading: true});
        
        post('/api/user/requestpasswordresettoken', {email: this.state.email})
        .then(() => this.onSuccess())
        .catch(ex => this.onError(ex))
        .finally(() => 
        {
            const loadingInterval = setInterval(() => this.reset(loadingInterval), 3000);
        });
    }

    render() {
        const title = this.props.title;

        const headerStyle = {
            'margin-bottom': '2rem'
        }

        const inputStyle = {
            'margin': '0'
        }

        const errorStyle = {
            'margin-bottom': '0.5rem',
            'height': '1rem'
        }

        const buttonStyle = {
            width: '100%'
        }

        return(
            <div className="full-height">
                {title && (<div className="row" style={headerStyle}>
                    <div className="columns"><span className="text-center"><h4>{title}</h4></span></div>
                </div>)}
                <div className="row">
                    <div className="columns small-12 medium-expand"/>
                    <div className="columns small-12 medium-expand">
                        <input style={inputStyle} className={`form__input ${this.state.invalidInput ? "invalidinput" : ""}`} 
                            id="email" name="email" type="email" placeholder={translate('forgotpassword.email')} 
                            onChange={(event) => this.onInputChanged(event)} 
                            value={this.state.email || ''}/>
                        <span id="error" style={errorStyle} className="form__validator--error">
                            { (this.state.isError && translate('forgotpassword.genericerror')) 
                            || (this.state.invalidInput && translate('forgotpassword.invalidinput'))}
                        </span>
                        <LoadingButton onClick={() => this.onSubmit(this.state.email)}
                            style = {buttonStyle}
                            submitText={translate('forgotpassword.submit')} 
                            errorText={translate('forgotpassword.error')} 
                            successText={translate('forgotpassword.success')}
                            isLoading={this.state.isLoading} isCompleted={this.state.isCompleted} isError={this.state.isError}/>
                    </div>
                    <div className="columns small-12 medium-expand"/>
                </div>
            </div>
        );
    }

}

export default ForgotPassword;
